// used at build time, so no TypeScript
import defaultConfig from "./default";

export default {
  ...defaultConfig,

  stage: "production",
  isProduction: true,
  USER_URL: "https://secure.ipdanalytics.com/User",
  IPD_URL: "https://secure.ipdanalytics.com",
  RUNTIME_GQL_URL: "https://platform-gateway.api.ipdanalytics.com/graphql",
  CACHE_URL: "https://lci-clinical-pipeline-server.api.ipdanalytics.com/cache",
  PDF_URL: "https://lci-clinical-pipeline-server.api.ipdanalytics.com/pdfReport",
  featureToggles: {
    ...defaultConfig.featureToggles,
    useOldLitigationLinks: false,
    useNewLitigationLinks: true,
    europeLaunchedGenerics: true,
    taiwanReleased: true,
    likelyComplexFormReleased: true,
    saudiArabiaReleased: true,
    saudiArabiaIsNew: true,
  },
};
